import type React from 'react';
import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export const panelFooterClassName =
  'shrink-0 border-t border-gray-200 bg-white/95 px-6 py-4 shadow-[0_-8px_20px_rgba(15,23,42,0.08)] backdrop-blur';

type PanelFooterProps = HTMLAttributes<HTMLDivElement> & {
  sticky?: boolean;
};

export const PanelFooter: React.FC<PanelFooterProps> = ({ className, children, sticky = false, ...props }) => (
  <div className={cn(sticky && 'sticky bottom-0 z-20', panelFooterClassName, className)} {...props}>
    {children}
  </div>
);
